<template>
  <section>
    <div>
      <h3>Group Management</h3>
      <p
        v-if="!isTestConnectionPassed"
        :class="$style.note"
      >
        Group management will be available after a successful
        connection test and the application supports this functionality.
      </p>
    </div>
    <transition
      :enterActiveClass="$style.slideEnterActive"
      :enterClass="$style.slideEnter"
      :leaveActiveClass="$style.slideLeaveActive"
      :leaveToClass="$style.slideLeaveTo"
    >
      <div v-if="isTestConnectionPassed">
        <div v-if="isGroupsSupported">
          <p :class="$style.sectionGeneralMargin">
            This service provider supports groups.
            Select this to manage groups and group
            membership{{ appName }}
          </p>
          <div :class="$style.sectionGeneralMargin">
            <PrettyToggle
              :config="prettyToggleConfig"
              :handleToggleChange="setScimGroupsEnable"
              label="Enable management of User Groups and Group Membership in this application"
              :labelFirst="true"
            />
          </div>
        </div>
        <div v-else>
          <p :class="$style.sectionGeneralMargin">
            Group management not available for this service provider.
          </p>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapState } from 'vuex';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import PrettyToggle from 'client/components/FormValidation/PrettyToggle.vue';

const { application } = ItemTypeConsts;
const ApplicationModel = StoreModelMap[application];

export default {
  name: 'GenericScimConnectorGroups',

  components: {
    PrettyToggle,
  },

  mixins: [
    IdentityManagementMixin,
  ],

  computed: {
    ...mapState(ApplicationModel, ['item']),

    appName() {
      const { name, displayName } = this.item;
      if (!['bookmark', 'saml2'].includes(name)) {
        return ` in ${displayName}.`;
      }
      return '.';
    },

    prettyToggleConfig() {
      return { value: this.isGroupsEnabled };
    },
  },
};
</script>

<style module>
@import '../../css/sections.css';
@import './css/IdentityManagementCommon.css';
</style>
